module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_3_de4d8fe913640169b874b717d326d5b4.png";